import React, { useEffect, useState } from 'react';

/**
 * Popup d'annonce pilotable SANS redéploiement.
 *
 * Elle lit /annonce.json sur le serveur au chargement de la page :
 *   { "active": true|false, "icon": "🌴", "title": "...",
 *     "message": "...", "highlight": "...", "footnote": "..." }
 *
 * Pour afficher/retirer une annonce (congés, jour férié, promo…) :
 * modifier annonce.json dans hPanel (Gestionnaire de fichiers) ou via FTP
 * dans domains/lefamilysbourg.com/public_html/ — c'est tout.
 */
const AnnouncementPopup = () => {
  const [annonce, setAnnonce] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    fetch(`${process.env.PUBLIC_URL}/annonce.json?ts=${Date.now()}`, { cache: 'no-store' })
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (data && data.active) {
          setAnnonce(data);
          setVisible(true);
        }
      })
      .catch(() => {});
  }, []);

  if (!visible || !annonce) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/65 p-4 backdrop-blur-sm"
      onClick={() => setVisible(false)}
    >
      <div
        className="relative w-full max-w-md rounded-2xl bg-white px-8 pb-8 pt-10 text-center shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="absolute right-4 top-3 text-3xl leading-none text-gray-400 transition-colors hover:text-gray-700"
          onClick={() => setVisible(false)}
          aria-label="Fermer"
        >
          &times;
        </button>
        {annonce.icon && <div className="mb-3 text-5xl">{annonce.icon}</div>}
        {annonce.title && (
          <div className="mb-2 text-2xl font-extrabold tracking-tight text-amber-900">{annonce.title}</div>
        )}
        {annonce.message && <div className="mb-1 text-lg leading-relaxed text-gray-700">{annonce.message}</div>}
        {annonce.highlight && (
          <div className="my-2 text-xl font-extrabold leading-snug text-orange-800">{annonce.highlight}</div>
        )}
        {annonce.footnote && <div className="mb-6 text-lg text-gray-600">{annonce.footnote}</div>}
        <button
          className="rounded-full bg-gradient-to-br from-amber-900 to-amber-600 px-10 py-3 text-base font-bold tracking-wide text-white shadow-lg transition-transform hover:-translate-y-0.5 hover:shadow-xl active:translate-y-0"
          onClick={() => setVisible(false)}
        >
          J'ai compris
        </button>
      </div>
    </div>
  );
};

export default AnnouncementPopup;
